
import {Component, Prop, VModel, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {authentication} from "@pazion/pazion-core/src/store";
import PazTooltipButton from '@pazion/pazion-core/src/components/controls/PazTooltipButton.vue';
import {
  IDocumentsForCategory,
  IRequiredDocument,
  IRequiredDocumentCategory
} from "@pazion/pazion-core/src/models/dossier.model";
import DossierRequiredDocument from "@pazion/pazion-core/src/views/dossier/parts/DossierRequiredDocument.vue";

@Component({
  components: {
    DossierRequiredDocument,
    PazTooltipButton
  }
})
export default class DossierRequiredDocumentCategory extends Vue {

  public emptyDocument: IRequiredDocument = {
    category: -1, isAdminOnly: false, isMandatory: false, personal: false,
    id: -1,
    name: 'Overig',
    isPresent: false
  };

  @Prop()
  public fileCategory!: IDocumentsForCategory;

  @Prop()
  public dossierId!: number;

  private clientcompletedFile: number = 0;

  get isAdmin() {
    return authentication.isAdmin;
  }

  bumpClientCompletedFiles() {
    this.clientcompletedFile++;
  }

  reloadFiles() {
    this.$emit('reloadFiles');
  }

  get totalFilesPresent() {
    let present = 0;
    this.fileCategory.documents.forEach(value => {
      if (!authentication.isAdmin) {
        if (value.isPresent && !value.isAdminOnly) {
          present++;
        }
      } else if (value.isPresent) {
        present++;
      }
    });
    return present + this.clientcompletedFile;
  }

  get totalFilesRequired() {
    let i = 0;
    for (let document of this.fileCategory.documents) {
      if (authentication.isAdmin) {
        if (document.isAdminOnly || document.isMandatory) {
          i++;
        }
      } else if (document.isMandatory && !document.isAdminOnly) {
        i++;
      }
    }
    return i;
    // return this.fileCategory.documents.length;
  }

  get progressInPercent() {
    return Math.min(100, this.totalFilesPresent / this.totalFilesRequired * 100);
  }

  get getTitle() {
    if (this.fileCategory.id > 0) {
      return `${this.fileCategory.number} - ${this.fileCategory.category.name}`;
    }
    return this.fileCategory.category.name;
  }

  get isValidCategory() {
    return this.fileCategory.category.id > 0;
  }

  get getIcon() {
    if (this.fileCategory.category.id > 0) {
      return 'mdi-check';
    }
    return 'mdi-puzzle-outline';

  }
}
